import React, {useEffect, useState} from 'react';
import AppBar from '@material-ui/core/AppBar';
import {Link, useHistory} from "react-router-dom";
import AccountCircle from '@material-ui/icons/AccountCircle';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import {useStyles} from './AppBarStyle'
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Home from "@material-ui/icons/Home";
import Tooltip from "@material-ui/core/Tooltip";
import {grey} from "@material-ui/core/colors";
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import WarningIcon from "@material-ui/icons/Warning";
import {DialogContent} from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import "./AppBarStyle.css"
import TimerIcon from "@material-ui/icons/Timer";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function AppBarComponent({
                                            isHomePageInput, sessionId, titleData, authenticated, user, data,
                                            currentView = "homePage", callbackShowRedoToast
                                        }) {

    const [anchorEl, setAnchorEl] = useState(null);
    const [showRedoDialog, setShowRedoDialog] = useState(false);
    const [showProgressDialog, setShowProgressDialog] = useState(false);
    const [isHomePage, setIsHomePage] = useState(isHomePageInput);
    const [sessionData, setSessionData] = useState(titleData);

    useEffect(() => setIsHomePage(isHomePageInput), [isHomePageInput]);
    useEffect(() => setSessionData(titleData), [titleData]);

    const classes = useStyles();
    const history = useHistory();

    const handleAccountMenuClose = () => {
        setAnchorEl(false);
    };

    const handleAccountMenuOpen = event => {
        setAnchorEl(event.currentTarget);
    };

    const calcMenuTitle = () => {
        if (window.location.href.includes("interviewSessions")) {
            return "ראיונות - " + sessionData;
        }
        if (window.location.href.includes("teamSessions")) {
            return "תרגילים - " + sessionData;
        }
        return "מעוז"
    };

    const handleRedoClick = async () => {
        setShowRedoDialog(false);
        setShowProgressDialog(true);
        const redoUrl = process.env.REACT_APP_BACKEND_URL + "/sessions/reset/" + sessionId;
        try {
            const res = await fetch(redoUrl, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                },
            });
            if (res.status === 401) {
                window.location.replace(process.env.REACT_APP_URL)
            }
            const data = await res.json();
            if (data.status === "Success") {
                setShowProgressDialog(false);
                callbackShowRedoToast();
            } else {
                // callbackShowErrorToast("ארעה שגיאה לא צפויה, נסו שנית במועד מאוחר יותר ");
            }
        }
        catch (error) {

        }
    };

    const renderMenu = (
        <Menu
            // TODO - talip fix this.
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleAccountMenuClose}
            style={{direction: "rtl"}}
        >
            <MenuItem onClick={() => {
                window.location.replace(process.env.REACT_APP_BACKEND_URL + "/auth/logout");
            }}>התנתק</MenuItem>
        </Menu>
    );

    return (
        <div>
            <AppBar
                position="static"
                className={classes.appBar}
                style={{direction: "rtl"}}>
                <Toolbar>
                    <Typography variant="h6" className={classes.title}>
                        {calcMenuTitle()}
                    </Typography>
                    {!isHomePage ? (
                        <div>
                            <Button
                                className={window.location.href.includes("interviewSessions") ? classes.chosenButton : classes.menuItem}
                                style={{textDecoration: 'none', color: 'black', fontSize: '14px'}}
                                onClick={() => history.push({
                                    pathname: "/interviewSessions",
                                    state: {
                                        id: sessionId,
                                        appBarData: sessionData,
                                        isAuthenticated: authenticated,
                                        user: user
                                    }
                                })}>
                                ראיונות
                            </Button>
                            <Button
                                className={window.location.href.includes("teamSessions") ? classes.chosenButton : classes.menuItem}
                                style={{textDecoration: 'none', color: 'black', fontSize: '14px'}}
                                onClick={() => history.push({
                                    pathname: "/teamSessions",
                                    state: {
                                        id: sessionId,
                                        appBarData: sessionData,
                                        isAuthenticated: authenticated,
                                        user: user
                                    }
                                })}>
                                תרגילים
                            </Button>
                        </div>
                    ) : ''}
                    <div className={classes.grow}/>
                    <Tooltip title="לחץ על מנת לחזור לדף הבית">
                        <Link to={{
                            pathname: "/",
                            state: {}
                        }} style={{textDecoration: 'none', color: 'black'}}>
                            <IconButton style={{color: 'black'}}><Home/></IconButton>
                        </Link>
                    </Tooltip>
                    {!isHomePageInput ? (<Tooltip title="לחץ על מנת לבצע שיבוץ מחדש">
                        <IconButton
                            onClick={() => setShowRedoDialog(true)}
                        >
                            <RotateLeftIcon style={{color: grey[900]}}/>
                        </IconButton>
                    </Tooltip>) : ""}
                    {!isHomePageInput ? (<Tooltip title="לחץ על מנת לייצא לפורמט הדפסה">
                        <Link to={{
                            pathname: "/resultsTable",
                            state: {data: data, currentView: currentView, sessionData: sessionData}
                        }}
                              style={{textDecoration: 'none', display: "table-cell"}}
                        >
                            <IconButton>
                                <ExitToAppIcon style={{color: grey[900]}}/>
                            </IconButton>
                        </Link>
                    </Tooltip>) : ""}
                    <IconButton
                        onClick={handleAccountMenuOpen}
                        style={{color: 'black'}}>
                        <AccountCircle/>
                    </IconButton>
                </Toolbar>
            </AppBar>
            {renderMenu}
            <Dialog open={showRedoDialog}
                    onClose={() => {
                        setShowRedoDialog(false)
                    }} maxWidth={false} dir="rtl">
                <DialogTitle className="redoDialog" disableTypography={true}>
                    <div className="Icon">
                        <WarningIcon/>
                    </div>
                    <div className="DialogHeader">
                        איפוס שיבוץ
                    </div>
                </DialogTitle>
                <DialogContent className="redoContent">
                    האם ברצונך להתחיל את תהליך השיבוץ מחדש?
                    <br/>
                    שים לב! השינויים שביצעת יימחקו.
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined"
                            onClick={() => {
                                setShowRedoDialog(false)
                            }}
                            color="primary" className="CancelButton">
                        בטל
                    </Button>
                    <Button variant="contained" color="primary"
                            onClick={handleRedoClick}
                            className="SubmitButton">
                        אשר
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={showProgressDialog}
                    maxWidth={false} dir="rtl">
                <DialogTitle className="ProgressDialog" disableTypography={true} dir="rtl">
                    <div className="Icon">
                        <TimerIcon/>
                    </div>
                    <div className="ProgressHeader">
                        אנא המתן
                    </div>
                </DialogTitle>
                <DialogContent className="RedoProgressContent">
                    <CircularProgress disableShrink/>
                    <div className="DialogHeader">
                        משבץ מחדש
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}
